/* eslint-disable no-undef */
<template>
  <div id="Dashboard" class="container is-fluid">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet">

    <!-- Header -->
    <HeroContainer title="Purchase Research Dashboard" />

    <section id="filters" style="display:flex; justify-content:center;">
      <div style="width:500px" >
        
        <div>
          <input type="text" class="input" placeholder="Part (optional)"
              v-model="part_number" @input="part_number=$event.target.value.toUpperCase()"/>
        </div>
          <div class="field has-addons" style="margin-top:1em;">
            <p class="control">
              <span class="select">
                <select id="date_range" 
                    v-model="date_range" @change="change_date(date_range)">
                  <option disabled hidden value="" style="color:grey;">Date Presets</option>
                  <option value='today'>Today</option>
                  <option value='week'>Week</option>
                  <option value='this_month'>This Month</option>
                  <option value='prev_month'>Prev Month</option>
                  <option value='this_quarter'>This Quarter</option>
                  <option value='prev_quarter'>Prev Quarter</option>
                  <option value='this_year'>This Year</option>
                  <option value='prev_year'>Prev Year</option>
                  <option value='all'>All</option>
                  <option disabled hidden value='custom'>Custom</option>
                </select>
              </span>
            </p>
            <p class="control  is-expanded">
              <VueDatePicker v-model="range" :enable-time-picker="false" range/>
            </p>
          </div>
        <div class="buttons is-right">
          <button @click='reset' class="button is-small is-white">Reset</button>
          <button @click='ajax_get_dashboard' class="button is-info">Filter</button>
        </div>
      </div>
    </section>

    <section id="dashboard_data" v-if="purchase_pending_rows.length>0">      
      <div class="title_div">
        <span class="site">Purchase Pending</span>
      </div>
      <vue-good-table 
        ref="table_purchase_pending"
        :name="'dash_margin'"
        :select-options="{ 
          enabled: true,
          selectOnCheckboxOnly: true,
          selectionText: 'parts selected',
        }"
        :pagination-options="{
          perPage: vgtable_paged_default,
          perPageDropdown: [3, 5, 7, 10, 20, 50],
          enabled: is_paged_purchase_pending
        }"
        :rows="purchase_pending_rows"
        :columns="columns"
      >
        <template v-slot:selected-row-actions>
          <button v-if="is_staff || dashboard_permissions.includes('purchase')" 
              @click="ajax_purchase_update(table_ref='table_purchase_pending', purchased=true)"
              style="margin-right:3em;">
                  Purchased
          </button>
          <button v-if="is_staff || dashboard_permissions.includes('purchase')" 
              @click="ajax_purchase_update(table_ref='table_purchase_pending', null, no_purchase=true)"
              style="margin-right:3em;">
                  No Purchase
          </button>
        </template>
      </vue-good-table>
      <div class="buttons is-right">
        <button class="button is-info"
          style="margin: 0.5em 0 0 0"
          @click="$emit('download-csv', [purchase_pending_rows, 'PurchaseDashboard', null])">
          Download CSV
        </button>
      </div>
    </section>

    <section id="dashboard_data" v-if="purchased_rows.length>0">      
      <div class="title_div">
        <span class="site">Purchased</span>
      </div>
      <vue-good-table 
        ref="table_purchased"
        :name="'dash_margin'"
        :select-options="{ 
          enabled: true,
          selectOnCheckboxOnly: true,
          selectionText: 'parts selected',
        }"
        :pagination-options="{
          perPage: vgtable_paged_default,
          perPageDropdown: [3, 5, 7, 10, 20, 50],
          enabled: is_paged_purchased
        }"
        :rows="purchased_rows"
        :columns="columns"
      >
        <template v-slot:selected-row-actions>
          <button v-if="is_staff || dashboard_permissions.includes('purchase')" 
              @click="ajax_purchase_update(table_ref='table_purchased', purchased=false, null)"
              style="margin-right:3em;">
                  Purchase Pending
          </button>
        </template>
      </vue-good-table>
      <div class="buttons is-right">
        <button class="button is-info"
          style="margin: 0.5em 0 0 0"
          @click="$emit('download-csv', [purchased_rows, 'PurchaseDashboard', null])">
          Download CSV
        </button>
      </div>
    </section>

    <section id="dashboard_data" v-if="no_purchase_rows.length>0">      
      <div class="title_div">
        <span class="site">No Purchase</span>
      </div>
      <vue-good-table 
        ref="table_no_purchase"
        :name="'dash_margin'"
        :select-options="{ 
          enabled: true,
          selectOnCheckboxOnly: true,
          selectionText: 'parts selected',
        }"
        :pagination-options="{
          perPage: vgtable_paged_default,
          perPageDropdown: [3, 5, 7, 10, 20, 50],
          enabled: is_paged_no_purchase
        }"
        :rows="no_purchase_rows"
        :columns="columns"
      >
        <template v-slot:selected-row-actions>
          <button v-if="is_staff || dashboard_permissions.includes('purchase')" 
              @click="ajax_purchase_update(table_ref='table_no_purchase', null, no_purchase=false)"
              style="margin-right:3em;">
                  Purchase Pending
          </button>
        </template>
      </vue-good-table>
      <div class="buttons is-right">
        <button class="button is-info"
          style="margin: 0.5em 0 0 0"
          @click="$emit('download-csv', [no_purchase_rows, 'PurchaseDashboard', null])">
          Download CSV
        </button>
      </div>
    </section>
  </div>
</template>

<style scoped>
  .title_div{
    margin-top: 1.5em;
  }

  .site{
    font-size: 2em;
  }

</style>

<script>
import { VueGoodTable } from 'vue-good-table-next';
import moment from 'moment';
var numeral = require('numeral');
import VueDatePicker from '@vuepic/vue-datepicker';
import { getDates } from '@/helpers/dates.js'
import HeroContainer from '@/components/shared/HeroContainer.vue';
import { DASHBOARD_PURCHASE, PURCHASE_RESEARCH_UPDATE_PURCHASE } from '@/data/url';
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/userStore'

export default {
  name: 'DashboardPurchase',
  components: {
    VueGoodTable,
    VueDatePicker,
    HeroContainer,
  },
  computed:{
    ...mapStores(useUserStore),
    is_staff: function(){
      return this.userStore.is_staff
    },
    dashboard_permissions: function(){
      let dashboard_permissions = this.userStore.dashboard_permissions
      if(dashboard_permissions){
        return dashboard_permissions
      }
      return []
    },
    queryData(){
      let raw_query = [...this.queryDataRaw]
      return raw_query
    },
    purchase_pending_rows(){
      let data =this.queryData
      let keep_rows = []
      for(let d of data){
        if(d.no_purchase==false & d.purchased==false){
          keep_rows.push(d)
        }
      }
      return keep_rows
    },
    purchased_rows(){
      let data =this.queryData
      let keep_rows = []
      for(let d of data){
        if(d.purchased==true){
          keep_rows.push(d)
        }
      }
      return keep_rows
    },
    no_purchase_rows(){
      let data =this.queryData
      let keep_rows = []
      for(let d of data){
        if(d.no_purchase==true){
          keep_rows.push(d)
        }
      }
      return keep_rows
    },
    is_paged_purchase_pending: function(){
      if(this.purchase_pending_rows.length <= this.vgtable_paged_default){
        return false
      }else{
        return true
      }
    },
    is_paged_purchased: function(){
      if(this.purchased_rows.length <= this.vgtable_paged_default){
        return false
      }else{
        return true
      }
    },
    is_paged_no_purchase: function(){
      if(this.no_purchase_rows.length <= this.vgtable_paged_default){
        return false
      }else{
        return true
      }
    },
    columns: function(){ return [          
            {
              label: 'Part Number',
              field: 'part_number',
              type: 'text',
            },
            {
              label: 'Description',
              field: 'description',
              type: 'text',
            },
            {
              label: 'Quantity',
              field: 'quantity',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('0,0,0,0,0')},
            },
            {
              label: 'UOM',
              field: 'unit_of_measure',
              type: 'text',
            },
            {
              label: 'Unit Cost',
              field: 'unit_cost',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
            },
            {
              label: 'Vendor',
              field: 'vendor',
              type: 'text',
            },
            {
              label: 'Notes',
              field: 'notes',
              type: 'text',
            },
            {
              label: 'Time Created',
              field: 'time_created',
              type: 'text',
              formatFn: function(value) {return moment(value).format('YYYY-MM-DD HH:mm')},
            },
            
          ]
    },
  },
  data: function(){
    return {
      vgtable_paged_default: 5,
      part_number: '',
      price_difference_low: '',
      price_difference_high: '',
      percent_difference_low: '',
      percent_difference_high: '',
      date_range: 'week',
      range: [
        moment().subtract(1, 'weeks').toDate(),
        moment().toDate()
      ],
      queryDataRaw: [],
      
    };
  },
  mounted: function(){
    this.ajax_get_dashboard()
  },
  methods: {
    getDates,
    reset(){
      this.queryDataRaw = []
      this.part_number = ''
      this.price_difference_low = ''
      this.price_difference_high = ''
      this.percent_difference_low = ''
      this.percent_difference_high = ''
      this.date_range=  'week'
      this.range = [
        moment().subtract(1, 'weeks').toDate(),
        moment().toDate()
      ]
    },
    change_date(date_range){
      let range = this.getDates(date_range)
      if(range){
        this.range = range
      }
    },
    set_searching(is_searching){
      this.searchStore.set_ajax_searching(is_searching)
    },
    filter_records(){
      this.ajax_get_dashboard(this.filter_customer, this.filter_user)
    },
    ajax_get_dashboard(){
      this.queryDataRaw = []
      let url = DASHBOARD_PURCHASE
      let time_created_begin = moment.utc(this.range[0]).format('YYYY-MM-DD')
      let time_created_end = moment.utc(this.range[1]).add(1,'day').format('YYYY-MM-DD')
      this.set_searching(true)
      let this_vue = this
      let part_number = this.part_number.trim()
      function set_dash(this_vue, dashboard){
        this_vue.queryDataRaw = dashboard
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({
          time_created_begin: time_created_begin, 
          time_created_end: time_created_end, 
          part_number: part_number
        }),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_dash(this_vue, res.dashboard)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
    ajax_purchase_update(table_ref, purchased=null, no_purchase=null){
      let url = PURCHASE_RESEARCH_UPDATE_PURCHASE
      this.set_searching(true)
      let rows = this.$refs[table_ref].selectedRows;
      let ids = []
      for(let row of rows){
        ids.push(row.id)
      }
      let this_vue = this
      function set_parts(this_vue, changed_data){
        for (let cd of changed_data){
          for(let row of this_vue.queryDataRaw){
            if (row.id == cd.id){
              row.purchased = cd.purchased
              row.no_purchase = cd.no_purchase
            }
          }
        }
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({id_list: ids, purchased: purchased, no_purchase: no_purchase}),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_parts(this_vue, res.data)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
  }
};

</script>
